<template>
  <div class="animated fadeIn">
    <!-- <div class="card p-4 mb-1"> -->
      <div class="form-group row">
        <div class="col-md-12 text-left">
          <h6 class="text-bold">
            <small>Protocolo: <strong>{{ numberProtocol }}</strong></small> <br> <small>Criado por: <strong>{{ createdBy }}</strong></small>
          </h6>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="blocks__container col-md-12 pb-1 d-flex d-md-down-none">
          <div class="card-leadinfo" :style="color">
            <div class="card-leadinfo-header" style="font-size: .75rem; padding-bottom: 3px">
              {{ boardColumnName }}
            </div>
            <div class="card-leadinfo-label">Situação</div>
          </div>
          <div class="card-leadinfo">
            <div class="card-leadinfo-header">
              {{ countDaysBetweenDateOfCreation }} <span class="card-leadinfo-label">Dias</span>
            </div>
            <div class="border-bottom my-1 mx-auto w-100" />
            <div>{{ formatDateDay }}</div>
            <div>{{ formatDateHour }}</div>
          </div>
          <div class="card-leadinfo">
            <div class="card-leadinfo-header">{{ percentual }}%</div>
            <div class="card-leadinfo-label">Fechamento</div>
          </div>
          <div class="card-leadinfo">
            <div class="card-leadinfo-header">{{ countContatos }}</div>
            <div class="card-leadinfo-label">Contatos</div>
          </div>
          <div class="card-leadinfo">
            <div class="card-leadinfo-header">{{ countAgendamentos }}</div>
            <div class="card-leadinfo-label">Agendamentos</div>
          </div>
        </div>
        <div class="col-md-12 d-sm-block d-md-none">
          <div class="card-leadinfo" :style="color">
            <div class="card-leadinfo-header" style="font-size: 15px; padding-bottom: 3px">
              {{ boardColumnName }}
            </div>
            <div class="card-leadinfo-label">Situação</div>
          </div>
          <div class="card-leadinfo mt-2">
            <div class="card-leadinfo-header">
              {{ countDaysBetweenDateOfCreation }} <span class="card-leadinfo-label">Dias</span>
            </div>
            <div class="border-bottom my-1 mx-auto w-75" />
            <div>{{ formatDateDay }}</div>
            <div>{{ formatDateHour }}</div>
          </div>
          <div class="card-leadinfo mt-2">
            <div class="card-leadinfo-header">{{ percentual }}%</div>
            <div class="card-leadinfo-label">Fechamento</div>
          </div>
          <div class="card-leadinfo mt-2">
            <div class="card-leadinfo-header">{{ countContatos }}</div>
            <div class="card-leadinfo-label">Contatos</div>
          </div>
          <div class="card-leadinfo mt-2">
            <div class="card-leadinfo-header">{{ countAgendamentos }}</div>
            <div class="card-leadinfo-label">Agendamentos</div>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>
<script>
import CrmDetailsInfo from './info.js'
export default CrmDetailsInfo
</script>
<style scoped>
.blocks__container{
  overflow-x: scroll;
}
.blocks__container::-webkit-scrollbar {
  height: 8px;
}
  .blocks__container::-webkit-scrollbar-thumb {
  background: #2e6e60B3 !important;
  border-radius: 3px !important;
}

.blocks__container::-webkit-scrollbar-thumb:hover {
  background: #2e6e60 !important;
  border-radius: 3px !important;
}

.blocks__container::-webkit-scrollbar-track {
  background-color: transparent;
}
.card-leadinfo {
  padding: 10px;
  border: solid 1px #d6d6d6;
  border-radius: 5px;
  background-color: #e5e5e5;
  min-width: 113px;
  text-align: center;
  margin-right: 10px;
  color: #6c757d;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.card-leadinfo-header {
  font-weight: bold;
  font-size: 18px;
}

.card-leadinfo-label {
  font-size: 12px;
}

.border-bottom {
  border-color: #d9d9d9 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/info/info.vue